import { createFileRoute } from "@tanstack/react-router";

import { McpClientPage } from "@/components/Mcp/McpClientPage";
import { getMcpClient } from "@/components/Mcp/mcpClients";
import { mcpClientHead } from "@/components/Mcp/mcpHead";

const client = getMcpClient("codex");

export const Route = createFileRoute("/mcp/codex")({
  component: () => <McpClientPage client={client} />,
  head: () => mcpClientHead(client),
});
